/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_List_All_CountriesInputs */



/**
* | output |
* | --- |
* | "All Countries" |
*
* @param {User_List_All_CountriesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_list_all_countries = /** @type {((inputs?: User_List_All_CountriesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_List_All_CountriesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tous les pays")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todos los países")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Todos os Países")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutte le Nazioni")
	return /** @type {LocalizedString} */ ("All Countries")
});